import { IPublishInventoryRow } from "@Settings/types/administrationTools/dealerManagementSystem";

function sanitizeItemsData(data: Omit<IPublishInventoryRow, "id">[]) {
	return data.map((obj) => {
		// eslint-disable-next-line no-unused-vars
		const { status, isActive, isCustom, isEditable, mappedName } = obj;
		return {
			name: status,
			isActive: Boolean(isActive) || false,
			isCustom: Boolean(isCustom) || false,
			isEditable: Boolean(isEditable) || false,
			mappedName: mappedName || "",
		};
	});
}

export { sanitizeItemsData };
